import React, { memo } from "react";
import styled from "styled-components";

const VotesTabContainer = styled.div``;

const AdminPageVotesTab = () => {
  return <VotesTabContainer>Admin Page Votes Tab</VotesTabContainer>;
};

export default memo(AdminPageVotesTab);
